// extracted by mini-css-extract-plugin
export default {"container":"TagPage_container__OaiTQ","textContainer":"TagPage_textContainer__+K1Do","productCard":"TagPage_productCard__hwbU7"};